import React from "react";

export const Io = () => {
  return (
    <div>
      <div
        id={"io"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
